import { Component, OnInit, ViewChild } from '@angular/core';
import { AdminService } from '../services/admin.service';
import {NotificationsService} from "angular2-notifications";
import { Router } from "@angular/router";
import { UserService } from '../services/user.service';
import { RecaptchaComponent } from 'ng-recaptcha';
@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {

  constructor(private adminService:AdminService,
              private router: Router,
              private userService: UserService,
              private  notifSer: NotificationsService,) { }
  adminLogin = {
    email: '',
    captcha: '',
    // password: '',
    // authflag: true,
    // _csrf: null
};

  @ViewChild('captchaRef') captchaRef: RecaptchaComponent;

  resetCaptcha() {
    this.adminLogin.captcha = '';
    if (this.captchaRef) {
      this.captchaRef.reset();
    }
  }
  ngOnInit() {
  }
  csrf() {
    // this.userService.csrf().subscribe((response) => {
    //     // console.log(response)
    //     this.adminLogin._csrf = response._csrf;
    // }, (err) => {
    //     this.notifSer.error(
    //         'Error CSRF',
    //         err.error.message,
    //         {
    //             timeOut: 3000,
    //             showProgressBar: true,
    //             pauseOnHover: false,
    //             clickToClose: true,
    //             maxLength: 50
    //         }
    //     )
    // });
}
  /**
   * reset password
   */
  Reset() {
    
    var validateemail = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/).test(this.adminLogin.email);
    console.log(validateemail)
    if(validateemail){
      this.adminService.verifyMailIdAdmin(this.adminLogin.email, this.adminLogin.captcha).subscribe((verifyresponse)=>{
        if(verifyresponse.result && verifyresponse.result != null){
          this.adminService.resetEmail(this.adminLogin.email, this.adminLogin.captcha).subscribe((result) => {
            this.notifSer.success(
              'Success',
              'Please check email for reset password',
              {
                  timeOut: 5000,
                  showProgressBar: true,
                  pauseOnHover: true,
                  clickToClose: true,
                  maxLength: 50
              }
          )
            // this.notifyService.showSuccess('', "Please check email for reset password");
            this.router.navigate(['reset-password']);
        }, (err) => {
          this.notifSer.error(
            'Error',
            err.error.message,
            {
                timeOut: 5000,
                showProgressBar: true,
                pauseOnHover: true,
                clickToClose: true,
                maxLength: 50
            }
        )
          this.resetCaptcha();
        })
        }else {
          this.notifSer.error(
            'Error',
            'Email not found or you are not an admin',
            {
                timeOut: 5000,
                showProgressBar: true,
                pauseOnHover: true,
                clickToClose: true,
                maxLength: 50
            }

        )
          this.resetCaptcha();
          // this.notifyService.showError('', result.message);
        }
      },(err)=>{
        this.notifSer.error(
          'Error',
          err.error.message,
          {
              timeOut: 5000,
              showProgressBar: true,
              pauseOnHover: true,
              clickToClose: true,
              maxLength: 50
          }

      )
        this.resetCaptcha();
      });
    }else{
      this.notifSer.error(
        'Error',
        'Please Enter Valid Email ID',
        {
            timeOut: 5000,
            showProgressBar: true,
            pauseOnHover: true,
            clickToClose: true,
            maxLength: 50
        }

    )
      // this.notifyService.showError('', 'Please Enter Valid Email ID');
    }
  }
  cancel(){
    this.router.navigate(['index']);
  }
}



// WEBPACK FOOTER //
// ./src/app/forgot-password/forgot-password.component.ts